import React, { useState } from "react";
//outsource
import { Row, Col, Select } from "antd";

//components

const DialogSelectBranch = ({
  branch,
  branchs,
  setBranch,
  onChange,
  disabled,
}) => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------

  //   console.log({ branch });
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleChange = (value) => {
    setBranch(value);
    onChange("branch", value);
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  const options = renderOptions(branchs);
  return (
    <Select
      style={{ minWidth: 160, width: "100%" }}
      placeholder="Select Branchs.."
      value={branch}
      options={options}
      onChange={handleChange}
      disabled={disabled}
      getPopupContainer={(trigger) => trigger.parentElement}
    />
  );
};

export default DialogSelectBranch;

const renderOptions = (branchs) => {
  const newOption = branchs?.map((item) => {
    const value = item?.id;
    const label = item?.name;
    return {
      value,
      label,
    };
  });

  return newOption;
};
